import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { BsSuitcaseLg } from "react-icons/bs";
import { FaSchoolCircleCheck } from "react-icons/fa6";

export const Timeline = () => {
    return (
        <VerticalTimeline>
            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: '#1D6A04', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #1D6A04' }}
                date="2017"
                iconStyle={{ background: '#1D6A04', color: '#fff' }}
                icon={<FaSchoolCircleCheck />}
            >
                <h4 className="vertical-timeline-element-title">Indian Certificate of Secondary Education</h4>
                <h5 className="vertical-timeline-element-subtitle">National Gems Higher Secondary School</h5>
                <h6 className="vertical-timeline-element-subtitle">Percentage Scored: 92%</h6>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: '#1D6A04', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #1D6A04' }}
                date="2019"
                iconStyle={{ background: '#1D6A04', color: '#fff' }}
                icon={<FaSchoolCircleCheck />}
            >
                <h4 className="vertical-timeline-element-title">Indian School Certificate</h4>
                <h5 className="vertical-timeline-element-subtitle">National Gems Higher Secondary School</h5>
                <h6 className="vertical-timeline-element-subtitle">Percentage Scored: 92.25%</h6>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#29046A', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #29046A' }}
                date="2021-2022"
                iconStyle={{ background: '#29046A', color: '#fff' }}
                icon={<BsSuitcaseLg />}
            >
                <h4 className="vertical-timeline-element-title">College Chapter President</h4>
                <h5 className="vertical-timeline-element-subtitle">CodeChef CIEM</h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#29046A', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #29046A' }}
                date="2022"
                iconStyle={{ background: '#29046A', color: '#fff' }}
                icon={<BsSuitcaseLg />}
            >
                <h4 className="vertical-timeline-element-title">Web Developer</h4>
                <h5 className="vertical-timeline-element-subtitle">Ardent Computech Pvt Ltd</h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                contentStyle={{ background: '#1D6A04', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #1D6A04' }}
                date="2019-2023"
                iconStyle={{ background: '#1D6A04', color: '#fff' }}
                icon={<FaSchoolCircleCheck />}
            >
                <h4 className="vertical-timeline-element-title">Bachelor of Technology in Information Technology</h4>
                <h5 className="vertical-timeline-element-subtitle">Calcutta Institute of Engineering and Management</h5>
                <h6 className="vertical-timeline-element-subtitle">Degree CGPA: 94.49</h6>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#29046A', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #29046A' }}
                date="2023"
                iconStyle={{ background: '#29046A', color: '#fff' }}
                icon={<BsSuitcaseLg />}
            >
                <h4 className="vertical-timeline-element-title">Web Developer</h4>
                <h5 className="vertical-timeline-element-subtitle">Bambhari</h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#29046A', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #29046A' }}
                date="2023"
                iconStyle={{ background: '#29046A', color: '#fff' }}
                icon={<BsSuitcaseLg />}
            >
                <h4 className="vertical-timeline-element-title">Software Programmer Trainee</h4>
                <h5 className="vertical-timeline-element-subtitle">MSQube Technology and Solutions Pvt Ltd</h5>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: '#29046A', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  #29046A' }}
                date="2024-Present"
                iconStyle={{ background: '#29046A', color: '#fff' }}
                icon={<BsSuitcaseLg />}
            >
                <h4 className="vertical-timeline-element-title">Associate Systems Engineer</h4>
                <h5 className="vertical-timeline-element-subtitle">IBM</h5>
            </VerticalTimelineElement>
        </VerticalTimeline>
    )
}
